import {
  useGetUserFormativeAssessments,
  useDeleteFormativeAssessment,
  getGetUserFormativeAssessmentsQueryKey,
  useGetTopFormativeAssessments,
  likeFormativeAssessment,
  unlikeFormativeAssessment,
  getGetTopFormativeAssessmentsQueryKey,
} from "@packages/api/madlenAPI";
import FormativeAssessmentCard from "../../components/formative-assessment/FormativeAssessmentCard";
import GenericToolPage from "../../components/tool_components/GenericToolPage";
import { FormativeAssessmentResponseDto } from "@packages/api/madlenAPI.schemas";

interface ExtendedFormativeAssessmentResponseDto
  extends FormativeAssessmentResponseDto {
  isEditable?: boolean;
}

const FormativeAssessmentDetailComponent = ({
  tool,
}: {
  tool: ExtendedFormativeAssessmentResponseDto;
}) => {
  return (
    <FormativeAssessmentCard assessment={tool} isEditable={tool.isEditable} />
  );
};

const FormativeAssessmentsView = () => {
  return (
    <GenericToolPage
      useGetTools={useGetUserFormativeAssessments}
      useDeleteTool={useDeleteFormativeAssessment}
      getGetToolsQueryKey={getGetUserFormativeAssessmentsQueryKey}
      useGetTopTools={useGetTopFormativeAssessments}
      likeTool={likeFormativeAssessment}
      unlikeTool={unlikeFormativeAssessment}
      getGetTopToolsQueryKey={getGetTopFormativeAssessmentsQueryKey}
      toolType="formativeAssessment"
      toolPath="formative-assessment"
      DetailComponent={FormativeAssessmentDetailComponent}
      colors={{
        light: "from-yellow-600 to-amber-600",
        dark: "dark:from-yellow-400 dark:to-amber-400",
        iconBg: "bg-yellow-100 dark:bg-yellow-900/50",
        iconColor: "text-yellow-600 dark:text-yellow-400",
        hover: "hover:bg-yellow-50 dark:hover:bg-yellow-900/20",
      }}
      toolColor="yellow"
      gradientColor="fuchsia"
    />
  );
};

export default FormativeAssessmentsView;
